import { Component, OnInit } from '@angular/core';
import { Application } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';

@Component({
  selector: 'jurisdiction-form',
  templateUrl: './jurisdiction-form.component.html',
  styleUrls: ['./jurisdiction-form.component.css']
})
export class JurisdictionFormComponent implements OnInit {
  title="Add jurisdiction";
  data : any = {};
  formInvalid : boolean = false;
  j : any = {};

  Jurt_id : number;
  mode : string;

  
  constructor(private UserService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    ) 
  { 

  }

  ngOnInit() {
    this.route.params.subscribe(params => {      
      this.Jurt_id = params['Jurt_id'];  
      this.mode =  params['mode'];   
        
        if(this.Jurt_id > 0){
          this.GetJurisdictionById(this.Jurt_id)
        }    
    });

    if(this.mode=='view'){
      this.title = "View Jurisdiction ";
    }
    else if(this.mode=='edit'){
      this.title = "Edit Jurisdiction ";
    }  
  }

  SaveJurisdiction(Jurisdiction: NgForm){ 
    
    if(Jurisdiction.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }     

    else{                                     
            this.data = this.UserService.PostJurisdiction(Jurisdiction.value);    
            this.data.subscribe(
            (response) => {
              Jurisdiction.reset();
              Jurisdiction.resetForm();
              Jurisdiction.form.markAsPristine();
              Jurisdiction.form.markAsUntouched();        
              swal('Success!', 'Jurisdiction Added Successfully .', 'success');
              this.router.navigate(['/home/jurisdiction/']) ;   
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });    
    
    
    } 
  }

  GetJurisdictionById(Jurt_id){
    document.getElementById('loader-spinner').style.display = "block";
        this.data = this.UserService.GetJurisdictionById(Jurt_id);
        this.data.subscribe(
          (response: any) => {
            this.j = response;        
                          
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401|| error.status == 500) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
  }
  UpdateJurisdiction(Jurisdiction: NgForm) {  
    this.data = this.UserService.UpdateJurisdiction(Jurisdiction.value,this.Jurt_id);
   this.data.subscribe(
     (response) => {
      Jurisdiction.reset();
      Jurisdiction.resetForm();
      Jurisdiction.form.markAsPristine();
      Jurisdiction.form.markAsUntouched();           
                   
       swal('Success!', 'Jurisdiction updated Successfully .', 'success');
       document.getElementById('loader-spinner').style.display = "none";   
       this.router.navigate(['/home/jurisdiction/']) ;          
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       if (error.status == 401|| error.status == 500) {
         this.errorHandler.HandlerError(error);
       }
       else if (error.status == 400) {
         swal('Warning!', error.error.Message, 'warning');
       }
     });   
}

Cancel(){
//this.router.navigate(['/home/district']) ; 
this.j.Jur_code='';
this.j.Jur_name='';
}
}





// WEBPACK FOOTER //
// ./src/app/masters/Jurisdiction/jurisdiction-form/jurisdiction-form.component.ts